import React, { useState } from "react";

const useFormData = (intialValue) => {
  const [formData, setFormData] = useState(intialValue);

  const updateFormData = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  return [formData,updateFormData]
};

export default useFormData;